import { MdDelete } from 'react-icons/md'

import type { DIGIT } from '../KeyboardButton'
import type { ReactElement } from 'react'

import KeyboardButton from '../KeyboardButton'

import AppLogo from '~/components/AppLogo'
import { FASTLY_PATH } from '~/const/asset'
import { useAppsManagementDetailsQuery } from '~/queries/application-management'
import { resize } from '~/utils/media'

interface Props {
  appKey?: string
  deviceType?: string
  keyLabel: DIGIT
  onDeleteClick?: VoidFunction
  viewPathLabel: string
}

const KeyboardBindingComponent = ({
  appKey,
  deviceType,
  keyLabel,
  onDeleteClick,
  viewPathLabel,
}: Props): ReactElement => {
  const { data: app } = useAppsManagementDetailsQuery(appKey)

  return (
    <div className="setting-modal__body__content__binding-mapping__keys" title={app?.default_display_name}>
      <div>
        <KeyboardButton size="small" type="ctrl" />
        <KeyboardButton digit={keyLabel as DIGIT} size="small" type="digit" />
        <div className="setting-modal__body__content__binding-mapping__keys__view-name">{viewPathLabel}</div>
      </div>
      {app ? (
        <AppLogo
          appLogoUrl={app.icon_file_id ? resize(`${FASTLY_PATH}${app.icon_file_id}`, 32, 32) : undefined}
          appPlatform={deviceType}
          size="small"
        />
      ) : null}
      <div className="setting-modal__body__content__binding-mapping__keys__delete-icon" onClick={onDeleteClick}>
        <MdDelete color="rgba(255, 0, 0, 0.724)" size={12} />
      </div>
    </div>
  )
}
export default KeyboardBindingComponent
